import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { API } from "../Services/Api";
import {
  aplicacao,
  aplicacao_full_url,
  app_base_url,
  enderecos_api,
  login_api,
} from "../Utils/Urls";

interface IEntidadeContextData {
  entidade: IEntidade;
  token: boolean | string;
  login: (usuario: string, senha: string) => Promise<void>;
  usuario: IUsuario;
  logout: () => void;
}

interface IEntidadeProviderProps {
  children: ReactNode;
}



const EntidadeContext = createContext({} as IEntidadeContextData);
export const token_storage = "@login-unico";
function EntidadeProvider({ children }: IEntidadeProviderProps) {
  const [entidade, setEntidade] = useState({} as IEntidade);
  const [usuario, setUsuario] = useState({} as IUsuario);
  const [token, setToken] = useState(false as boolean | string);
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  async function getEntidadePorNomeDoBanco() {
    try {
      setLoading(true);
      const d = window.location.href.split("/");
      const indexOf = d.indexOf(app_base_url.replace("/", "")) + 1;
      const entidade_carregada = await axios.get(
        `${enderecos_api}/cod/${d[indexOf]}`
      );

      if (entidade_carregada.data.length > 0) {
        entidade_carregada.data[0].logo =
          enderecos_api + "/uploads/" + entidade_carregada.data[0].logo;

        setEntidade(entidade_carregada.data[0]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getEntidadePorNomeDoBanco();
  }, [window.location.href]);

  async function checarToken() {
    setLoading(true);
    try {
      setLoading(true);
      const token = localStorage.getItem(token_storage);
      //window.alert(token)
      if (token) {
        const API_LOGIN = axios.create({
          baseURL: login_api,
        });

        API_LOGIN.defaults.headers.common["Authorization"] = `Bearer ${token}`;
   
        const { data } = await API_LOGIN.get("/checar-token");
        

        const permissao = data.usuario.sistemas.filter(
          (i: any) => i.titulo == aplicacao
        );
        if (permissao.length > 0) {

       // window.alert(data.usuario.entidade.banco.replace("1-", "").replace("2-", "").toLowerCase())
          // window.alert( `Bearer ${token}`);
          if (
            window.location.href.toLowerCase().indexOf(
              data.usuario.entidade.banco.replace("1-", "").replace("2-", "").toLowerCase()
            ) != -1
          ) {
            
            API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            setUsuario(data.usuario);
            setEntidade(data.usuario.entidade);
          }
   
        }
      
      
       
      }
    } catch (error) {
   
    } finally {
      setLoading(false);
    }
  }


  async function login(usuario: string, senha: string) {
    try {
      setLoading(true);
    } catch (error) {
      setAlert({ titulo: "Ops", mensagem: "Não foi possível efeturar login!" });
    } finally {
      setLoading(false);
    }
  }
  function logout() {
    try {
      setLoading(true);
      localStorage.removeItem(token_storage);
      setUsuario({} as IUsuario);
    } catch (error) {
      setAlert({
        titulo: "Ops",
        mensagem: "Não foi possível efeturar LOGOUT!",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // window.alert("to aqui")
    checarToken();
  }, []);

  return (
    <EntidadeContext.Provider
      value={{
        entidade,
        token,
        login,
        usuario,
        logout,
      }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </EntidadeContext.Provider>
  );
}

function useEntidade() {
  const context = useContext(EntidadeContext);

  return context;
}

export { EntidadeProvider, useEntidade };

interface IUsuario {
  usuario: {
    id: number;
    entidade_id: number;
    usuario: string;
    senha: string;
    email: string;
    inativo: null | string;
    nome: string;
    foto: null | string;
  };
  entidade: IEntidade;
  sistemas: [
    {
      id: number;
      titulo: string;
      url: string;
    }
  ];
}

interface IEntidade {
  id: number;
  titulo: string;
  banco: string;
  logo: string;
  apresentacao: string;
  portal: string;
  site: string;
  site2: string;
  pasta: string;
  pasta_unico:string;
}
